import "./applianceDetailsMadeIn.scss";

import React from "react";
import { useTranslation } from "react-i18next";

import usaFlag from "../../images/icons/usa.png";
import canadaFlag from "../../images/icons/canada.png";

export default function ApplianceDetailsMadeIn(props: {
    isMadeInCanada: boolean;
    isMadeInUSA: boolean;
}) {
    const { t } = useTranslation("layout");
    const { isMadeInCanada, isMadeInUSA } = props;
    return (
        <div className="made-in-container">
            <>
                {isMadeInCanada && (
                    <div className="made-in-canada">
                        <img className="made-in-flag" src={canadaFlag} alt="" />
                        <span className="made-in-text">{t("appliance.canada")}</span>
                    </div>
                )}
                {isMadeInUSA && (
                    <div className="made-in-usa">
                        <img className="made-in-flag" src={usaFlag} alt="" />
                        <span className="made-in-text">{t("appliance.usa")}</span>
                    </div>
                )}
            </>
        </div>
    );
}
